function Header() {

    return (

        <header>

            <h1>Welcome to My Telegram Mini App</h1>

        </header>

    );

}

export default Header;
